// Exports
export default {
	"stubWrapper": "stubWrapper_tVuOF",
	"link": "link_sBBae"
};
